<template>
  <tr>
    <!-- Date  -->
    <td>
      <router-link :to="`/appointment_detail/${id}`">
        <span @click="preventRemoveResults">{{ formattedDate }}</span>
      </router-link>
    </td>

    <!-- Time -->
    <td align="right">
      <router-link :to="`/appointment_detail/${id}`">
        <!-- Actual Time -->
        <span @click="preventRemoveResults">
          {{ formattedTime }}
        </span>

        <!-- AM/PM -->
        <span v-if="app_start_tt === 0" @click="preventRemoveResults"
          >AM {{ getAbbrFromTz(timezone) }}</span
        >
        <span v-else @click="preventRemoveResults"
          >PM {{ getAbbrFromTz(timezone) }}</span
        >
      </router-link>
    </td>
  </tr>
</template>

<script>
import { dateAndTimeMixin } from "../../../mixins/dateAndTimeMixin";
import moment from "moment-timezone";
import { mapGetters } from "vuex";

export default {
  mixins: [dateAndTimeMixin],
  props: {
    id: Number, // The appointment id
    app_start_hh: Number, // The start hour
    app_start_mm: Number, // The start minute
    app_start_tt: Number, // The start AM/PM
    app_date: String, // The date
    timezone: String, // The Timezone string eg-Asia/Kolkata
    preventRemoveResults: Function // Prevent removal of result
  },
  computed: {
    formattedTime() {
      return this.formatTimeOnlyTime(this.app_start_hh, this.app_start_mm);
    },
    formattedDate() {
      const [year, month, dayOfMonth] = this.app_date.split("-");
      return `${month}-${dayOfMonth}-${year}`;
    },
    ...mapGetters({
      loggedInTimezone: "getLoggedInTimezone"
    })
  },
  methods: {
    getAbbrFromTz(value) {
      if (value === null) {
        return null;
      }
      var abbr = moment()
        .tz(value)
        .zoneAbbr();
      if (abbr.charAt(0) == "+" || abbr.charAt(0) == "-") {
        return null;
      } else {
        return abbr;
      }
    },
    getTz(timezone, loggedInTimezone) {
      if (this.app_start_tt === 0) {
        var str =
          this.app_date +
          " " +
          moment(this.formattedTime + " AM", ["h:mm A"]).format("HH:mm");
        // AM
      } else {
        str =
          this.app_date +
          " " +
          moment(this.formattedTime + " PM", ["h:mm A"]).format("HH:mm");
        // PM
      }
      return moment(new Date(str))
        .tz(loggedInTimezone)
        .format("MM-DD-YYYY h:mm A z");
    }
  }
};
</script>
